export const useTimestampChecks = () => {
    const isAirdropEnded = () => {
        return Date.now() >= 1763078400000;
    };
    
    return {
        isAirdropEnded,
    };
};